export default __webpack_public_path__ + "static/media/close.f62862c6.svg";